<div class="ngx-mat-tel-input-container gb-intl-phone-input-container">
  <button
    type="button"
    mat-button
    [matMenuTriggerFor]="menu"
    class="country-selector"
    [disabled]="disabled"
    disableRipple
    disableFocusRipple
    disableTouchRipple
  >
    <div class="button-content">
      <gb-flag-icon [flagClass]="selectedCountry.flagClass"></gb-flag-icon>
      @if (selectedCountry.dialCode) {
        <span class="country-selector-code">+{{ selectedCountry.dialCode }}</span>
      }
      <span class="dropdown-icon"></span>
    </div>
  </button>
  <mat-menu #menu="matMenu">
    <input
      class="country-search"
      [(ngModel)]="searchCriteria"
      type="text"
      [placeholder]="searchPlaceholder"
      (click)="$event.stopPropagation()"
      id="search"
      #searchInput
    />
    @for (country of preferredCountriesInDropDown | search: searchCriteria; track country) {
      <button type="button" mat-menu-item class="country-list-button" (click)="onCountrySelect(country)">
        <div class="icon-label-wrapper">
          <div class="icon-wrapper">
            <gb-flag-icon [flagClass]="country.flagClass"></gb-flag-icon>
          </div>
          <div class="label-wrapper">
            ({{ country.iso2.toUpperCase() }})
            @if (country?.dialCode) {
              <span>+{{ country.dialCode }}</span>
            }
          </div>
        </div>
      </button>
    }
    @if (preferredCountriesInDropDown.length) {
      <mat-divider></mat-divider>
    }
    @for (country of allCountriesInDropDown | search: searchCriteria; track country) {
      @if (country) {
        <button type="button" mat-menu-item class="country-list-button" (click)="onCountrySelect(country)">
          <div class="icon-label-wrapper">
            <div class="icon-wrapper">
              <gb-flag-icon [flagClass]="country.flagClass"></gb-flag-icon>
            </div>
            <div class="label-wrapper">({{ country.iso2.toUpperCase() }}) +{{ country.dialCode }}</div>
          </div>
        </button>
      }
    }
  </mat-menu>

  <input
    matInput
    type="tel"
    autocomplete="off"
    (blur)="onTouched()"
    (keypress)="onInputKeyPress($event)"
    [(ngModel)]="phoneNumber"
    (ngModelChange)="onPhoneNumberChange()"
    [errorStateMatcher]="errorStateMatcher"
    [disabled]="disabled"
    [aria-describedby]="describedBy"
    #matInput="matInput"
  />
</div>
